import { selectPathFilterGridData } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type Row = {
    activity: string;
};

export type GridRow = Row & { id: number }

export type SetPathFilterSelectedDataProps = ApiMethodBase & {
    selection: Row[];
    type: string;
};

export const setPathFilterSelectedData = ({
    selection,
    type,
}: SetPathFilterSelectedDataProps) => {
    selectPathFilterGridData(selection, type);
    
};
